import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from 'Redux/LoggedUserSlice';
import { useLocation } from 'react-router-dom';
import NavBar from './Components/NavBar';
import Paper from './Components/Paper';
import useFetch from './Hooks/useFetch';
import ui from './index.module.css';

export default function index() {
  const { id: userId } = useSelector(userSelector);
  const [userEvaluation, setUserEvaluation] = useState(null);
  const location = useLocation();
  const { titleLesson, titleCourse, totalQuestions, lessonId, duration, courseId } = location.state;

  const { startTest } = useFetch({
    lessonId,
    titleCourse,
    titleLesson,
    duration,
    courseId,
    userId,
    setUserEvaluation,
  });

  return (
    <div className={ui.mainContainer}>
      <NavBar title={titleCourse} />
      <Paper
        title={titleLesson}
        numberQuestions={totalQuestions}
        onClick={startTest}
        duration={duration}
        userEvaluation={userEvaluation}
      />
    </div>
  );
}
